<div
  class="usa-modal"
  id="download-modal"
  aria-labelledby="modal-heading"
  aria-describedby="modal-content"
>
  <div class="usa-modal__content">
    <div class="usa-modal__main">
      <h2 class="usa-modal__heading" id="modal-heading">
        @if (!hasError()) {
          @if (!isDownloadingResults()) {
            Download Search Results
          } @else {
            Downloading Search Results...
          }
        } @else {
          Download Error
        }
      </h2>
      <p id="modal-content">
        @if (!hasError()) {
          @if (!isDownloadingResults()) {
            Click on the link below to download the data.
          } @else {
            Please be patient - depending on the number of results, this can take a while.
          }
        } @else {
          There was an error preparing the results for download. Please try again.
        }
      </p>
      <div class="usa-modal__footer">
        @if (!hasError()) {
          @if (!isDownloadingResults()) {
            <a
              class="usa-button usa-button--unstyled"
              [href]="downloadLink()"
              download="SearchResults.csv"
              (click)="onAction()"
              >SearchResults.csv</a
            >
          } @else {
            <div style="color: lightgray">
              SearchResults.csv &nbsp;
              <div class="downloadLoader"></div>
            </div>
          }
        }
      </div>
    </div>
    <button
      type="button"
      class="usa-button usa-modal__close"
      aria-label="Close this window"
      data-close-modal
    >
      <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
        <use xlink:href="/assets/img/sprite.svg#close"></use>
      </svg>
    </button>
  </div>
</div>
